if (!customElements.get('my-rewards')) {

    class MyReward extends HTMLElement {

        myDiscounts = []
        discounts = []
        loading = false;
        constructor(props) {
            super(props)
        }

        connectedCallback() {
            console.log("MyReward", this.id);

            window.addEventListener('load', this.onWindowLoaded)
            window.addEventListener("click", this.onWindownClick)
        }

        disconnectedCallback() {
            console.log("MyReward disconnectedCallback", this.id);

            window.removeEventListener('load', this.onWindowLoaded)
            window.removeEventListener("click", this.onWindownClick)
        }

        initEvent() {

            document.getElementById("btn-apply-discount-code").addEventListener("click", () => {
                console.log("code");
                var code = document.getElementById("input-apply-discount-code").value;
                if (code) {
                    this.disableEnalbeDiscountUI(true);

                    StoreFrontAPI.instance.applyDiscount(code).then(res => {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                        this.disableEnalbeDiscountUI(false);

                        this.getListDiscountCOde();
                        if (res == false) {
                            document.getElementById("message-apply-discount").classList.remove("d-none")
                        } else {
                            document.getElementById("message-apply-discount").classList.add("d-none")
                        }

                    })

                }
            })

            this.getListReward();
            // this.getListDiscountCOde()

        }
        onWindowLoaded = () => {
            requestAnimationFrame(() => {
                this.getListReward();
            })
            document.getElementById(this.id + "-btn-point-redeem").addEventListener("click", () => {
                this.redeem()
            })

        }
        async redeem() {
            let point = Number(document.getElementById(this.id + "-input-point-redeem").value);
            if (isNaN(point)) {
                return;
            }
            var elError = document.getElementById(this.id + "-redeem-error");
            if (elError) elError.textContent = ""

            document.getElementById(this.id + "-input-point-redeem").setAttribute("disabled", "true")
            document.getElementById(this.id + "-btn-point-redeem").classList.add("loading");
            var token = await window.getToken();
            var res = await fetch(`${window.BackendUrl}/customer/reward/redeem`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ point: point })
            })
            var response = await res.json();
            this.getElementsByClassName("btn-redeem").item(0).classList.remove("loading");

            if (document.getElementById(this.id + "-input-point-redeem")) document.getElementById(this.id + "-input-point-redeem").removeAttribute("disabled")


            if (response && response.success) {
                this.discountData = response.body.data;
                this.updateMyPoint(response.body.customer.reward_point)

                StoreFrontAPI.instance.applyDiscount(this.discountData.discount_code).then(res => {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                })
                this.classList.add("redeemed")
            } else {
                if (elError) {
                    elError.textContent = response.message;
                }
            }
        }
        updateMyPoint(point) {
            var elements = document.getElementsByClassName("my-reward-point")
            for (let index = 0; index < elements.length; index++) {
                const element = elements.item(index);
                var text_point = window.rewardStrings.current_hero_point.replace("{{ point }}", point);
                element.textContent = point > 1 ? `${text_point}` : `${text_point} ${window.rewardStrings.hero_point}`

            }
        }
        showCodeRedemmed = (itemRedeemed) => {
            this.classList.add("show-redeemed-code")

        }
        async getListDiscountCOde() {
            var container = document.getElementById("container-discount-code-applied");
            var discounts = await StoreFrontAPI.instance.getDiscountCodes();
            this.discounts = discounts;
            container.innerHTML = ""
            discounts = discounts.filter(el => el.applicable)

            for (let index = 0; index < discounts.length; index++) {
                const element = discounts[index];
                const div = document.createElement("div");
                div.classList = ["discount-applied-item"]
                div.innerHTML = `${this.getDiscountIcon()}<span class="discount-code">${element.code}</span>`
                container.append(div)

                const button = document.createElement("button");
                button.classList = "btn-remove-discount"
                button.innerHTML = this.getRemoveDiscountIcon();
                button.addEventListener("click", () => {
                    div.remove()
                    this.disableEnalbeDiscountUI(true);
                    StoreFrontAPI.instance.removeDiscount(element.code).then(res => {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                        this.getListDiscountCOde()
                        this.disableEnalbeDiscountUI(false);
                    })
                })
                div.append(button)

            }
        }
        onWindownClick = (event) => {
            var dropdownReward = document.getElementById("dropdown-redeem")
            var dropdown = document.getElementById('dropdown-discount')
            function isDescendant(parent, child) {
                var node = child.parentNode;
                while (node != null) {
                    if (node == parent) {
                        return true;
                    }
                    node = node.parentNode;
                }
                return false;
            }
            if ((dropdown != event.target && dropdownReward != event.target) && isDescendant(dropdown, event.target) == false) {
                if (!event.target.matches('.dropbtn')) {
                    var dropdowns = document.getElementsByClassName('dropdown-content');
                    var i;
                    for (i = 0; i < dropdowns.length; i++) {
                        var openDropdown = dropdowns[i];
                        if (openDropdown.classList.contains('show')) {
                            openDropdown.classList.remove('show');
                            console.log('remove-');
                        }
                    }
                }
            }
        }


        disableEnalbeDiscountUI(isLoading) {
            var buttonsApply = this.getElementsByClassName("btn-apply-discount");
            for (let index = 0; index < buttonsApply.length; index++) {
                const element = buttonsApply[index];
                if (isLoading) {
                    element.classList.add("loading")
                } else {
                    element.classList.remove("loading")
                }
            }

            var items = this.getElementsByClassName("discount-applied-item")
            for (let index = 0; index < items.length; index++) {
                const element = items.item(index);
                if (isLoading) {
                    element.classList.add("loading")
                } else {
                    element.classList.remove("loading")
                }
            }
        }
        async fetchData() {
            var token = await window.getToken();
            var res = await fetch(`${window.BackendUrl}/customer/reward/list-redeemed`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: undefined
            })
            var response = await res.json();
            if (response && response.success) {
                if (response.body && response.body.length > 0) {
                    this.myDiscounts = response.body;
                    this.renderListDiscountRedeemed(response.body);
                    document.getElementById("control-reward").classList.remove("d-none")
                }
                else {
                    document.getElementById("control-reward").classList.add("d-none")
                }
            }
        }

        toNodes = (html) => new DOMParser().parseFromString(html, 'text/html').body.childNodes[0];

        renderListDiscountRedeemed(data) {
            var container = document.getElementById("discount-container");
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                let { discount_code } = element;
                let name = element.reward_info.name;

                let itemEL = this.toNodes(`<div class="discount-item">
                    <div class="container-title ">
                      <div class="discount-title">${name}</div>
                      <div class="discount-code">${discount_code}</div>
                    </div>
                    <div class="container-btn">
                      <button class="btn-apply-discount">Apply</button>
                    </div>
                  </div>`)
                let button = itemEL.getElementsByClassName("btn-apply-discount").item(0);
                button.addEventListener("click", () => {
                    this.disableEnalbeDiscountUI(true);

                    StoreFrontAPI.instance.applyDiscount(discount_code).then(res => {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
                        this.getListDiscountCOde()
                        this.disableEnalbeDiscountUI(false);
                    })
                })

                container.append(itemEL);
            }
        }

        getDiscountIcon() {
            return `<div><svg width="15px" style="margin-right:5px;"
  aria-hidden="true"
  focusable="false"
  class="icon icon-discount"
  viewBox="0 0 12 12"
>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
</svg></div>`
        }
        getRemoveDiscountIcon() {
            return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>`
        }

        async getListReward() {
            var token = await window.getToken();
            var res = await fetch(`${window.BackendUrl}/customer/reward/list`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: undefined
            })
            var response = await res.json();
            if (response && response.success) {
                var elements = document.getElementsByClassName("my-reward-point");
                for (let index = 0; index < elements.length; index++) {
                    const element = elements.item(index)
                    var text_point = window.rewardStrings.current_hero_point.replace("{{ point }}", response.body.point);
                    element.innerHTML = text_point;
                }
                // this.renderListReward(response.body.rewards, response.body.point);
                if (response.body.enable) {
                    this.classList.remove("inactive")
                    document.getElementById("control-reward").classList.remove("inactive")
                }
                if (document.getElementById("total-point-customer")) {
                    document.getElementById("total-point-customer").innerHTML = response.body.point;
                }
            }
            var content = document.getElementById('reward-content');
            content.style.maxHeight = content.scrollHeight + 20 + 'px';
        }
        renderListReward(rewards, point) {
            var container = document.getElementById(this.id + "reward-container");
            for (let index = 0; index < rewards.length; index++) {
                const element = rewards[index];
                let item = document.createElement("my-reward-item");
                item.parentID = this.id;
                item.data = element;
                item.myPoint = point

                container.append(item)
            }
        }
    }

    customElements.define(
        'my-rewards',
        MyReward
    );

}
